import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Message } from 'primereact/message';
import React, { LegacyRef, useRef, useState } from "react";
import { IFormData, IRegisterFormProps } from "../../interfaces";

import { Toast } from "primereact/toast";
import { ToastSeverity } from 'utils/enums';
import '../../styles.css';

export const RegisterForm = (props: IRegisterFormProps) => {
    const toast = useRef<LegacyRef<Toast> | null>(null);
    const [invalidValues, setInvalidValues] = useState<Array<string>>([]);

    const defaultValues = {
        name: '',
        surname: '',
        email: '',
        reemail: '',
        phone: '',
        company: ''
    }

    const [formData, setFormData] = useState<IFormData>({
        timeSlot: new Date(props.selectedDateTime).getTime(),
        timeZoneOffset: new Date(props.selectedDateTime).getTimezoneOffset(),
        timezoneId: Intl.DateTimeFormat().resolvedOptions().timeZone || '',
        name: defaultValues.name,
        surname: defaultValues.surname,
        email: defaultValues.email,
        reemail: defaultValues.reemail,
        company: defaultValues.company,
        phone: defaultValues.phone,
    });

    const convertDateToString = (d: Date): string => {
        var datestring = d.getFullYear() + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2)
            + " " + ("0" + d.getHours()).slice(-2) + ":" + ("0" + d.getMinutes()).slice(-2);
        return datestring;
    }

    const handleScheduleEvent = () => {
        var dataIsValid = true;
        var tempInvalidInputs = [];

        var optionalFields = ['company', 'timezoneId'];// TODO show error if browser does not support 'timezoneId

        for (const [key, value] of Object.entries(formData)) {
            if (!optionalFields.includes(key)) {
                if (!value) {
                    tempInvalidInputs.push(key);
                    dataIsValid = false;
                }
            }
        }
        if (formData.email !== formData.reemail) {
            dataIsValid = false;
        }
        setInvalidValues(tempInvalidInputs);

        if (dataIsValid) {
            props.onScheduleEvent(formData);
        } else {
            showToast(ToastSeverity.ERROR, "Error", "Fields must be filled");
        }
    }

    const validateStringInput = (value: string, handler: CallableFunction, field: string) => {
        if (value) {
            handler(value, field);
        } else {
            handler('', field);
        }
    }

    const handleFieldChange = (value: string, field: string) => {
        var tempData = { ...formData };
        // @ts-ignore
        tempData[`${field}`] = value;
        setFormData(tempData);
    }

    const submitBtnText = () => {
        return props.scheduling ? "Please wait..." : "Submit booking";
    }

    const chunkStyle = {
        margin: '10px',
        // width: '100%',
    }

    const inputStyle = {
        width: '100%',
    }

    const inputInvalidStyle = {
        width: '60%',
    }

    // @ts-ignore
    const showToast = (severity: ToastSeverity, summary: string, detail: string, lifetime: number = 3000) => { toast.current.show({ severity: severity, summary: summary, detail: detail, life: lifetime }); };

    return (
        <div className="flex justify-content-center">
            {/* @ts-ignore */}
            <Toast ref={toast} sticky />
            {/* <div className="card"> */}
            <div style={{ maxWidth: '600px', height: 'auto', margin: '0 auto', padding: '10px', position: 'relative' }}>
                <div className="formgroup-inline mb-2" style={chunkStyle}>
                    Event time: <strong>{convertDateToString(new Date(props.selectedDateTime))}</strong>
                </div>

                <div className="formgroup-inline mb-2" style={chunkStyle}>
                    <label htmlFor="name" className="p-sr-only">Name</label>
                    <InputText id="name" placeholder="Name*" onChange={(e) => validateStringInput(e.target.value, handleFieldChange, 'name')} style={invalidValues.includes('name') ? inputInvalidStyle : inputStyle} className={invalidValues.includes('name') ? "p-invalid" : ""} />
                    {
                        invalidValues.includes('name') && <Message severity="error" text="Name is required" />
                    }
                </div>

                <div className="formgroup-inline mb-2" style={chunkStyle}>
                    <label htmlFor="surname" className="p-sr-only">Surname</label>
                    <InputText id="surname" placeholder="Surname*" onChange={(e) => validateStringInput(e.target.value, handleFieldChange, 'surname')} style={invalidValues.includes('surname') ? inputInvalidStyle : inputStyle} className={invalidValues.includes('surname') ? "p-invalid" : ""} />
                    {
                        invalidValues.includes('surname') && <Message severity="error" text="Surname is required" />
                    }
                </div>

                <div className="formgroup-inline" style={chunkStyle}>
                    <label htmlFor="email" className="p-sr-only">Email</label>
                    <InputText id="email" placeholder="Email*" onChange={(e) => validateStringInput(e.target.value, handleFieldChange, 'email')} style={invalidValues.includes('email') ? inputInvalidStyle : inputStyle} className={invalidValues.includes('email') ? "p-invalid" : ""} />
                    {
                        invalidValues.includes('email') && <Message severity="error" text="Email is required" />
                    }
                </div>
                <div className="formgroup-inline" style={chunkStyle}>
                    <label htmlFor="reemail" className="p-sr-only">Re-enter email</label>
                    <InputText id="reemail" placeholder="Re-enter email" onChange={(e) => validateStringInput(e.target.value, handleFieldChange, 'reemail')} style={invalidValues.includes('reemail') || formData.email !== formData.reemail ? inputInvalidStyle : inputStyle} className={invalidValues.includes('reemail') || formData.email !== formData.reemail ? "p-invalid" : ""} />
                    {
                        invalidValues.includes('reemail') ? (
                            <Message severity="error" text="Email is required" />
                        ) : (
                            formData.email !== formData.reemail &&
                            <Message severity="error" text="Emails must match" />
                        )
                    }
                </div>

                <div className="formgroup-inline" style={chunkStyle}>
                    <label htmlFor="company" className="p-sr-only">Company</label>
                    <InputText id="company" placeholder="Company" onChange={(e) => handleFieldChange(e.target.value, 'company')} style={inputStyle} />
                </div>

                <div className="formgroup-inline" style={chunkStyle}>
                    <label htmlFor="phone" className="p-sr-only">Phone*</label>
                    <InputText id="phone" placeholder="Phone*" onChange={(e) => validateStringInput(e.target.value, handleFieldChange, 'phone')} style={invalidValues.includes('phone') ? inputInvalidStyle : inputStyle} className={invalidValues.includes('phone') ? "p-invalid" : ""} />
                    {
                        invalidValues.includes('phone') && <Message severity="error" text="Phone is required" />
                    }
                </div>

                <div style={chunkStyle}>
                    <div className={props.isMobile ? '' : 'p-d-flex'} style={{ padding: '10px' }}>
                        <div>
                            <Button label='Cancel' onClick={() => { props.handleConfimCancel() }} className='p-button-danger p-button-text' />
                        </div>
                        <div style={{ marginLeft: 'auto' }}>
                            <Button label={submitBtnText()} disabled={props.scheduling} onClick={() => handleScheduleEvent()} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

